import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { API_URL, scroll, getValFromLS, isFieldError } from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";
import Select from "../../components/Select";
import Input from "../../components/Input";
import Checkbox from "../../components/Checkbox";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Nav from "../Nav";

const Other = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef();
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardHotelOtherInit`);
			const params = {
				id: auth.id ? auth.id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });

					setDetails({
						...json,
					});

					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		if (name === "method" && value === "yourself") {
			setNames((names) => ({
				...names,
				fname: user.fname,
				lname: user.lname,
				email: user.email,
				confirm: user.email,
			}));
		}
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardHotel`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (
				key === "sun1" ||
				key === "mon1" ||
				key === "tue1" ||
				key === "wed1" ||
				key === "thu1" ||
				key === "fri1" ||
				key === "sat1" ||
				key === "sun2" ||
				key === "mon2"
			) {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});
		data.append("thu1Selected", names.thu1 ? "thu1" : "");
		data.append("fri1Selected", names.fri1 ? "fri1" : "");
		data.append("sat1Selected", names.sat1 ? "sat1" : "");
		data.append("sun2Selected", names.sun2 ? "sun2" : "");
		data.append("hotel", "lacantera");
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/dashboard/hotel`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Dashboard" />
						<p>Use this form create a new hotel request for an occupant.</p>

						<ul>
							<li>
								For suite requests, please contact Samantha Murray at (210)
								345-5279 or email{" "}
								<a href="mailto:valerobfc@valero.com">valerobfc@valero.com</a>.
							</li>

							<li style={{ fontWeight: "bold" }}>
								Please note that this form does not guarantee your request will
								be honored, but will be reviewed and approved based upon
								availability.
							</li>
						</ul>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Add a La Cantera Room Occupant
							</h4>

							<div className="form-group">
								<Select
									name="bed"
									label="Bed Preference (not guaranteed)"
									reqd={true}
									value={""}
									options={[
										{ id: "", name: "--" },
										{ id: "nopref", name: "No Preference" },
										{ id: "king", name: "1 King Bed" },
										{ id: "double", name: "2 Queen Beds" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "bed")}
								/>

								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="name"
									label="Name"
									reqd={true}
									value={names.name || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>

								<Input
									name="email"
									label="Email"
									reqd={true}
									value={names.email || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<h4
								style={{
									marginTop: "20px",
									lineHeight: "22px",
									marginBottom: "0",
									fontSize: "1.1rem",
								}}
							>
								Include the Following Nights
							</h4>

							<div className="checkbox-grid">
								{details.nights.map((item) => {
									return (
										<div
											className="form-group checkbox"
											style={{
												marginLeft: "15px",
												marginTop: "0",
												marginBottom: "5px",
											}}
											key={item.name}
										>
											<Checkbox
												name={item.name}
												label={item.label}
												checked={false}
												click={handleUpdate}
												disabled={item.disabled}
											/>
										</div>
									);
								})}
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/dashboard/hotel"
										left="Back"
										submit="Create Room Request"
									/>
								</div>
							</div>
						</form>
						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Other;
